module.exports = __webpack_public_path__ + "img/selbsterfahrung_960.cfaeba90.webp";